import { initBackButton } from "/src/shared/back-button.js"; initBackButton();